import React, { ReactNode } from 'react';
import { MenuContext } from './context';
import Item, { ItemType } from './item';
import SubMenu, { SubMenuType } from './submenu';

const { Provider } = MenuContext;

interface IMenuProps {
  children?: ReactNode;
  defaultOpenKeys?: string[];
  style?: Object;
  isNeedHideAll?: boolean;
}
interface IMenu {
  Item: ItemType;
  SubMenu: SubMenuType;
}

const Menu: React.FC<IMenuProps> & IMenu = ({
  children, defaultOpenKeys = [], style = {}, isNeedHideAll,
}) => {
  // 判断子节点是否为 Item 或者 SubMenu
  // ...
  return (
    <Provider
      value={{
        defaultOpenKeys,
        isNeedHideAll,
      }}
    >
      <div style={style}>
        {children}
      </div>
    </Provider>
  );
};

Menu.Item = Item;
Menu.SubMenu = SubMenu;

export default Menu;
